var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('el-container',{staticClass:"indexcontainer"},[_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require("../../image/logo/admin_banner.jpg"),"alt":""}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b996cf5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/system/homeIndex.vue
// module id = null
// module chunks = 